/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MoneyCurrencyRubleIcon24Regular = forwardRef('MoneyCurrencyRubleIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.75 3.25a1.5 1.5 0 0 0-1.5 1.5v8.5H5a.75.75 0 0 0 0 1.5h2.25v2.5H5a.75.75 0 0 0 0 1.5h2.25V21a.75.75 0 0 0 1.5 0v-2.25H14a.75.75 0 0 0 0-1.5H8.75v-2.5H14a5.75 5.75 0 0 0 0-11.5H8.75Zm5.25 10H8.75v-8.5H14a4.25 4.25 0 0 1 0 8.5Z" })));
});
